import {Cart} from './cart';
import { Product } from './product';

export class UpgradeData {
  upgradeCart: Cart;
  startDate: string;
  endDate: string;
  product: Product;

  constructor(upgradeData?: any) {
    if (upgradeData) {
      this.startDate = upgradeData.startDate;
      this.endDate = upgradeData.endDate;
      this.product = new Product(upgradeData.product);
      this.product = upgradeData.product;

      this.upgradeCart = new Cart(upgradeData.upgradeCart);
    }
  }
}
